import { render, staticRenderFns } from "./SensorDetailEvs.vue?vue&type=template&id=15283d09&scoped=true"
import script from "./SensorDetailEvs.vue?vue&type=script&lang=ts"
export * from "./SensorDetailEvs.vue?vue&type=script&lang=ts"
import style0 from "./SensorDetailEvs.vue?vue&type=style&index=0&id=15283d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15283d09",
  null
  
)

export default component.exports